/* eslint-disable import/prefer-default-export */
import { getCurrentInstance } from 'vue';

// Get the current Vue app instance for accessing global properties
const getAppInstance = () => {
  const instance = getCurrentInstance();
  return instance?.appContext.app.config.globalProperties || instance?.proxy || null;
};

const checkIfAxiosError = (error) => !!error.response;
const checkForErrorArray = (axiosErrorData) => Array.isArray(axiosErrorData);
const checkForServiceObject = (axiosErrorData) => typeof axiosErrorData === 'object' && 'success' in axiosErrorData;

export const showErrorToast = (error) => {
  const appInstance = getAppInstance();
  
  if (!appInstance?.$toast) {
    console.error('Toast plugin not found. Make sure it\'s properly installed and configured.');
    console.error(error);
    return;
  }

  if (!checkIfAxiosError(error)) {
    appInstance.$toast.error(error);
    return;
  }

  const axiosErrorData = error.response.data;

  if (checkForErrorArray(axiosErrorData)) {
    appInstance.$toast.error(axiosErrorData[0]);
    return;
  }

  if (checkForServiceObject(axiosErrorData)) {
    appInstance.$toast.error(axiosErrorData.errors[0]);
    return;
  }

  appInstance.$toast.error(axiosErrorData);
};